export default "__VITE_ASSET__Djof85N$__"